import { render, staticRenderFns } from "./BaseCarouselSlide.vue?vue&type=template&id=40320056&"
import script from "./BaseCarouselSlide.vue?vue&type=script&lang=js&"
export * from "./BaseCarouselSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports